import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

interface EfOurPartnersProps {
    /**
     * title
     */
    title?: string;
    /**
     * items
     */
    items?: string[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护: kalkin
 *
 * 主标题
 */
const EfOurPartners: React.FC<EfOurPartnersProps> = ({ className, title, items }) => {
    const prefixCls = `ef-our-partners`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    const partners =
        items?.length > 0
            ? items
            : [
                  {
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1726110163009/WINNEBAGO.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1726110959528/Frame%20161269768.png',
                  },
                  {
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1726110163907/REI.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1726110959950/Group%20161269661.png',
                  },
                  {
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1726110163476/WestMarine.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1726111030690/Group%20161269661%20(1).png',
                  },
                  {
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1726110163265/FENDT.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1726110960146/Group%20161269661%20(2).png',
                  },
                  {
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1726110163747/CAMPERVAN.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1726110960360/Group%20161269659.png',
                  },
              ];

    return (
        <div className={classes}>
            {title && <p className={`${prefixCls}-title`}>{title}</p>}
            <ul className={`${prefixCls}-items`}>
                {partners.map((img: string, index: number) => (
                    <li className={`${prefixCls}-item`}>
                        <EfImg pc={img.pc} h5={img?.h5} />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EfOurPartners;
